/**
 * @generated SignedSource<<513885b092394ae336e0915ed64bf66b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type AddPolicyCollectionInput = {
  autoUpdate?: boolean | null | undefined;
  description?: string | null | undefined;
  items?: ReadonlyArray<PolicyCollectionElement> | null | undefined;
  name: string;
  owner?: any | null | undefined;
  provider: CloudProvider;
  repositoryUUID?: string | null | undefined;
  repositoryView?: AddRepositoryViewInput | null | undefined;
};
export type PolicyCollectionElement = {
  policyUUID: string;
  policyVersion?: number | null | undefined;
};
export type AddRepositoryViewInput = {
  branchName?: string | null | undefined;
  policyDirectories?: ReadonlyArray<string> | null | undefined;
  policyFileSuffix?: ReadonlyArray<string> | null | undefined;
  startRevSpec?: string | null | undefined;
};
export type AddPolicyCollectionMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddPolicyCollectionInput;
};
export type AddPolicyCollectionMutation$data = {
  readonly addPolicyCollection: {
    readonly collection: {
      readonly autoUpdate: boolean;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly policyMappings: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly policy: {
              readonly name: string;
              readonly uuid: any;
              readonly version: number;
            };
          };
        }>;
      };
      readonly provider: CloudProvider | null | undefined;
      readonly roleAssignmentTarget: any;
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
};
export type AddPolicyCollectionMutation = {
  response: AddPolicyCollectionMutation$data;
  variables: AddPolicyCollectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoUpdate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentTarget",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddPolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "addPolicyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollectionMappingConnection",
                "kind": "LinkedField",
                "name": "policyMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolicyCollectionMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PolicyCollectionMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Policy",
                            "kind": "LinkedField",
                            "name": "policy",
                            "plural": false,
                            "selections": [
                              (v6/*:: as any*/),
                              (v7/*:: as any*/),
                              (v8/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "AddPolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "addPolicyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollectionMappingConnection",
                "kind": "LinkedField",
                "name": "policyMappings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PolicyCollectionMappingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PolicyCollectionMapping",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Policy",
                            "kind": "LinkedField",
                            "name": "policy",
                            "plural": false,
                            "selections": [
                              (v6/*:: as any*/),
                              (v7/*:: as any*/),
                              (v8/*:: as any*/),
                              (v5/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "collection",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PolicyCollectionEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bba32638d44bfd7b2da90de9c20dd37b",
    "id": null,
    "metadata": {},
    "name": "AddPolicyCollectionMutation",
    "operationKind": "mutation",
    "text": "mutation AddPolicyCollectionMutation(\n  $input: AddPolicyCollectionInput!\n) {\n  addPolicyCollection(input: $input) {\n    collection {\n      autoUpdate\n      description\n      id\n      name\n      policyMappings {\n        edges {\n          node {\n            policy {\n              name\n              uuid\n              version\n              id\n            }\n            id\n          }\n        }\n      }\n      provider\n      roleAssignmentTarget\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "744a5f5ca859d108f43ff4649c6166ea";

export default node;
